<template>
    <div class='skill-groups-overview'>
        <page-top :title="$t('pages.groups-overview.title')" :breadcrumbs="breadcrumbs" :background="'#ffffff'" />

        <div class="container" v-if="skillGroups.length">
            <section class="groups-section">
                <div class="column is-10 is-offset-1">
                    <div class="groups columns is-multiline">
                        <div v-for="group in skillGroups" class="column is-one-third">
                            <router-link :to="{ name: 'skills.group', params: { group: group.name }}">
                                <div class="card">
                                    <div class="card-image">
                                        <figure class="image is-3by1">
                                            <img :src="$t(`skills.groups.${group.name}.imageUrl`)" :alt="$t(`skills.groups.${group.name}.name`)">
                                        </figure>
                                    </div>

                                    <div class="card-content">
                                        <h2 class="title is-size-4">{{$t(`skills.groups.${group.name}.name`)}}</h2>
                                        <p class="subtitle is-size-6">{{$t(`skills.groups.${group.name}.teaser`)}}</p>
                                    </div>
                                </div>
                            </router-link>
                        </div>

                        <div class="column is-one-third">
                            <router-link :to="{name: 'contact'}">
                                <div class="card">
                                    <div class="card-image">
                                        <figure class="image is-3by1">
                                            <img src="/static/images/groups/challenge.jpeg" alt="Har du en udfordring?" style="object-fit: cover">
                                        </figure>
                                    </div>

                                    <div class="card-content">
                                        <h2 class="title is-size-4">Har du en udfordring?</h2>
                                        <p class="subtitle is-size-6">Hvis du finder en opgave vi ikke dækker, så <router-link :to="{name: 'contact'}">kontakt os her</router-link>, så kan vi måske hjælpe.</p>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="container" v-else>
            <section class="articles">
                <div class="column is-10 is-offset-1">
                    <div class="card article">
                        <div class="card-content has-text-centered">
                            <h1 class="is-size-4">Indlæser...</h1>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/_variables';

    .skill-groups-overview {
        background: $background-blueish;
    }
</style>

<script>
    import SkillGroupService from '@/taskflex/skills/services/SkillGroupService';
    import PageTop from '@/global/components/PageTop';

    export default {
        data() {
            return {
                skillGroups: [],
            };
        },

        mounted() {
            this.load();
        },

        computed: {
            breadcrumbs() {
                return [
                    {
                        title: this.$t('pages.home.title'),
                        route: { name: 'home' },
                    },
                    {
                        title: this.$t('pages.groups-overview.title'),
                        route: { name: 'skills.groups-overview' },
                    },
                ];
            },
        },

        methods: {
            load() {
                const options = {
                    includes: ['skills'],
                };

                SkillGroupService.findAll(options, (response) => {
                    const { rows } = response.data;

                    this.skillGroups = rows;
                });
            },
        },

        components: {
            PageTop,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/skills/pages/GroupsOverview.vue